"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Defines human-readable versions of KeyboardEvent.keyCode:
// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
var keyCodes = {
    Enter: 13,
    Space: 32,
    ArrowUp: 38,
    ArrowDown: 40,
};
exports.default = keyCodes;
